import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Footer from '../Components/Footer';
import Auth from '../Function/Auth';
import Header from '../Components/Header';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function Client() {
  const authToken = localStorage.getItem('token');
  const baseurl = process.env.REACT_APP_BASE_API_URL;
  const [analytics, setAnalytics] = useState({});
  const [tableLoading, setTableLoading] = useState(false);
  const [clientData, setClientData] = useState([]);
  const [pagination, setPagination] = useState({
    current_page: 1,
    limit: 10,
    total_records: 0,
    total_pages: 0,
  });
  const [clientEmail, setClientEmail] = useState('');
  const [clientName, setClientName] = useState('');
  const [userStatus, setUserStatus] = useState('');
  const [statics, setStatics] = useState([]); // Initialize as empty array

  useEffect(() => {
    fetchDataClient(1);
  }, []);

  const fetchDataClient = async (page) => {
    setTableLoading(false);


    try {
      const response = await fetch(`${baseurl}/userList.php?page=${page}&name=${clientName}&email=${clientEmail}&status=${userStatus}`, {
        method: 'GET', // Changed to GET since the API uses query parameters
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${authToken}`,
        },
      });

      if (response.status === 429) {
        toast.error('Rate limit exceeded. Please try again later.');
        setTableLoading(true);
        return;
      }

      const data = await response.json();
      console.log('API Response:', data);

      if (data.status) {
        setClientData(data.data);
        setPagination(data.pagination);
        setAnalytics(data.statistics);
        setTableLoading(true);
      } else {
        toast.error(data.message || 'Failed to fetch user data');
        setTableLoading(true);
      }
    } catch (error) {
      console.error('Fetch error:', error);
      toast.error('Network error. Please check your connection and try again.');
      setTableLoading(true);
    }
  };

  const handlePageChange = (page) => {
    if (page >= 1 && page <= pagination.total_pages) {
      fetchDataClient(page);
    }
  };

  const searchData = () => {
    fetchDataClient(1);
  };

  const handleProfileDataFetched = (data) => {
    // Handle profile data if needed
  };

  const setUserDetails = (userId) => {
    localStorage.setItem("userID", userId);
    window.location.href = '/clientsDetails';
  };

  return (
    <>
      <Header>
        {!authToken && <Auth onProfileDataFetched={handleProfileDataFetched} />}
        <div className="main-content app-content">
          <div className="container-fluid">
            {/* Page Header */}
            <div className="d-md-flex d-block align-items-center justify-content-between my-4 page-header-breadcrumb">
              <h1 className="page-title">Client Management</h1>
            </div>

            {/* Analytics Cards */}
            <div className="row">
              <div className="col-xl-3 col-lg-6 col-md-6 col-sm-12">
                <div className="card overflow-hidden sales-card bg-primary-gradient">
                  <div className="px-3 pt-3 pb-2">
                    <h6 className="mb-3 fs-12 text-fixed-white">TOTAL USERS</h6>
                    <h4 className="fs-20 fw-bold mb-1 text-fixed-white">
                      {analytics?.total_user || 0}
                    </h4>
                  </div>
                </div>
              </div>
              <div className="col-xl-3 col-lg-6 col-md-6 col-sm-12">
                <div className="card overflow-hidden sales-card bg-warning-gradient">
                  <div className="px-3 pt-3 pb-2">
                    <h6 className="mb-3 fs-12 text-fixed-white">PENDING USERS</h6>
                    <h4 className="fs-20 fw-bold mb-1 text-fixed-white">
                      {analytics?.pending_user || 0}
                    </h4>
                  </div>
                </div>
              </div>
              <div className="col-xl-3 col-lg-6 col-md-6 col-sm-12">
                <div className="card overflow-hidden sales-card bg-danger-gradient">
                  <div className="px-3 pt-3 pb-2">
                    <h6 className="mb-3 fs-12 text-fixed-white">BLOCKED USERS</h6>
                    <h4 className="fs-20 fw-bold mb-1 text-fixed-white">
                      {analytics?.block_user || 0}
                    </h4>
                  </div>
                </div>
              </div>
              <div className="col-xl-3 col-lg-6 col-md-6 col-sm-12">
                <div className="card overflow-hidden sales-card bg-success-gradient">
                  <div className="px-3 pt-3 pb-2">
                    <h6 className="mb-3 fs-12 text-fixed-white">ACTIVE USERS</h6>
                    <h4 className="fs-20 fw-bold mb-1 text-fixed-white">
                      {analytics.active_user || 0}
                    </h4>
                  </div>
                </div>
              </div>
            </div>

            {/* Filter Section */}
            <div className="row">
              <div className="col-md-12 col-lg-12 col-xl-12">
                <div className="card card-table">
                  <div className="row">
                    <div className="col-xl-3 col-lg-6 col-md-6 col-sm-12">
                      <div className="mt-3">
                        <label>Name</label>
                        <input
                          type="text"
                          value={clientName}
                          onChange={(e) => setClientName(e.target.value)}
                          className="form-control"
                          placeholder="Enter user name"
                        />
                      </div>
                    </div>
                    <div className="col-xl-3 col-lg-6 col-md-6 col-sm-12">
                      <div className="mt-3">
                        <label>Email</label>
                        <input
                          type="text"
                          value={clientEmail}
                          onChange={(e) => setClientEmail(e.target.value)}
                          className="form-control"
                          placeholder="Enter user email"
                        />
                      </div>
                    </div>
                    <div className="col-xl-3 col-lg-6 col-md-6 col-sm-12">
                      <div className="mt-3">
                        <label>Status</label>
                        <select
                          className="form-control"
                          value={userStatus}
                          onChange={(e) => setUserStatus(e.target.value)}
                        >
                          <option value="">All</option>
                          <option value="active">Active</option>
                          <option value="pending">Pending</option>
                          <option value="block">Blocked</option>
                        </select>
                      </div>
                    </div>
                    <div className="col-xl-3 col-lg-6 col-md-6 col-sm-12">
                      <div className="mt-3 text-end">
                        <button
                          onClick={searchData}
                          className="btn btn-primary btn-block mt-4"
                        >
                          Search
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Table Section */}
            <div className="row">
              <div className="col-md-12 col-lg-12 col-xl-12">
                <div className="card card-table">
                  <div className="card-header p-0 d-flex justify-content-between mt-3">
                    <h3 className="card-title mb-1 text-primary">User Data</h3>
                  </div>
                  <div className="table-responsive country-table">
                    {tableLoading ? (
                      <table className="table table-striped table-bordered mb-0 text-nowrap mt-3">
                        <thead>
                          <tr>
                            <th>NAME</th>
                            <th>SPONSOR ID</th>
                            <th>EMAIL</th>
                            <th>REGISTER DATE</th>
                            <th>DEPOSIT AMOUNT</th>
                            <th>STAKE AMOUNT</th>
                            <th>STATUS</th>
                            <th>ACTION</th>
                          </tr>
                        </thead>
                        <tbody>
                          {clientData.length > 0 ? (
                            clientData.map((dataClient, index) => (
                              <tr key={index}>

                                <td>
                                  <h5>{dataClient.name || 'N/A'}</h5>
                                </td>
                                <td>{dataClient.sponsor_id || 'N/A'}</td>
                                <td>{dataClient.email || 'N/A'}</td>
                                <td>
                                  {dataClient.joidDate
                                    ? `${dataClient.joidDate} ${dataClient.joinTime}`
                                    : 'N/A'}
                                </td>
                                <td>${dataClient.depositAmount || 0}</td>
                                <td>${dataClient.stakeAmount || 0}</td>
                                <td>
                                  <span
                                    className={`badge bg-${dataClient.accountStatus === 'active'
                                      ? 'success'
                                      : dataClient.accountStatus === 'pending'
                                        ? 'warning'
                                        : 'danger'
                                      }`}
                                  >
                                    {dataClient.accountStatus || 'N/A'}
                                  </span>
                                </td>
                                <td>
                                  <a
                                    onClick={() => setUserDetails(dataClient.id)}

                                    className="btn btn-sm btn-primary"
                                  >
                                    <i className="fa fa-eye"></i>
                                  </a>
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="9" className="text-center">
                                No Data Found
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    ) : (
                      <div className="text-center">
                        <div className="spinner-border" role="status">
                          <span className="visually-hidden">Loading...</span>
                        </div>
                      </div>
                    )}
                  </div>
                  <div className="gridjs-footer">
                    <div className="gridjs-pagination">
                      <div
                        role="status"
                        aria-live="polite"
                        className="gridjs-summary"
                      >
                        Showing <b>{(pagination.current_page - 1) * pagination.limit + 1}</b> to{' '}
                        <b>
                          {Math.min(
                            pagination.current_page * pagination.limit,
                            pagination.total_records
                          )}
                        </b>{' '}
                        of <b>{pagination.total_records}</b> results
                      </div>
                      <div className="gridjs-pages text-end">
                        <button
                          className={pagination.current_page === 1 ? 'disabled' : ''}
                          onClick={() => handlePageChange(pagination.current_page - 1)}
                          disabled={pagination.current_page === 1}
                        >
                          Previous
                        </button>
                        <button
                          className={pagination.current_page === 1 ? 'gridjs-currentPage' : ''}
                          onClick={() => handlePageChange(1)}
                        >
                          1
                        </button>
                        {pagination.current_page > 3 && <span>...</span>}
                        {Array.from({ length: 5 }, (_, i) => {
                          const page = pagination.current_page - 2 + i;
                          if (page > 1 && page < pagination.total_pages) {
                            return (
                              <button
                                key={page}
                                className={
                                  pagination.current_page === page ? 'gridjs-currentPage' : ''
                                }
                                onClick={() => handlePageChange(page)}
                              >
                                {page}
                              </button>
                            );
                          }
                          return null;
                        })}
                        {pagination.current_page < pagination.total_pages - 2 && (
                          <span>...</span>
                        )}
                        {pagination.total_pages > 1 && (
                          <button
                            className={
                              pagination.current_page === pagination.total_pages
                                ? 'gridjs-currentPage'
                                : ''
                            }
                            onClick={() => handlePageChange(pagination.total_pages)}
                          >
                            {pagination.total_pages}
                          </button>
                        )}
                        <button
                          class混乱
                          className={
                            pagination.current_page === pagination.total_pages ? 'disabled' : ''
                          }
                          onClick={() => handlePageChange(pagination.current_page + 1)}
                          disabled={pagination.current_page === pagination.total_pages}
                        >
                          Next
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <ToastContainer />
      </Header>
      <Footer />
    </>
  );
}

export default Client;